<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page-v"></a><em>To</em></p>
<p class="dedication1"><em>DAPHNE</em></p>
<p class="dedication1"><em>in the confidence</em></p>
<p class="dedication1"><em>that her abounding sympathy</em></p>
<p class="dedication1"><em>will extend even to poor</em></p>
<p class="dedication1"><em>Pinfold</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?903564a6